'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.string = exports.props = exports.signal = exports.input = exports.state = exports.Tag = undefined;

var _Tag = require('./Tag');

Object.defineProperty(exports, 'Tag', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tag).default;
  }
});

var _Tag2 = _interopRequireDefault(_Tag);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createTemplateTag(tag, options) {
  return function (strings) {
    for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      values[_key - 1] = arguments[_key];
    }

    if (values.some(function (value) {
      return value === undefined;
    })) {
      (0, _utils.throwError)('One of the values passed inside the tag interpolated to undefined. Please check');
    }
    return new _Tag2.default(tag, options, strings, values);
  };
}

var state = exports.state = createTemplateTag('state', {
  isStateDependency: true
});

var inputTemplateTag = createTemplateTag('input');
var input = exports.input = function input() {
  console.warn('DEPRECATION: The INPUT template tag is deprecated, use props');

  return inputTemplateTag.apply(undefined, arguments);
};
var signal = exports.signal = createTemplateTag('signal');
var props = exports.props = createTemplateTag('props');
var string = exports.string = createTemplateTag('string', {
  hasValue: false
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/cerebral/lib/tags/index.js
// module id = 392
// module chunks = 0